<template>
    <v-card>
        <v-layout>
            <v-navigation-drawer v-model="drawer" :rail="rail" permanent @click="rail = false"
                class="position-fixed bg-sidebar">

                <!-- <v-list-item prepend-avatar="https://randomuser.me/api/portraits/men/1.jpg" :title="user.nombres" nav>
                    <template v-slot:append>
                        <v-btn variant="text" icon="mdi-chevron-left" @click.stop="rail = !rail"></v-btn>
                    </template>

                </v-list-item> -->
                <v-list-item prepend-avatar="https://randomuser.me/api/portraits/men/1.jpg" :title="roluserData?.rol " nav>
                    
                    <template v-slot:append>
                        <v-btn variant="text" icon="mdi-chevron-left" @click.stop="rail = !rail"></v-btn>
                    </template>
                        </v-list-item>
                <h6 style="text-align: center;">{{ userData?.nombres }}</h6>
                <v-divider></v-divider>
                <v-list>
                    <v-list-group>
                        <template v-for="(menu, index) in datos" :key="index">
                            <v-list-group :key="index" v-if="shouldShowMenu(menu)" rounded="xl" color="white darken-1">
                                <template v-slot:activator="{ props }">
                                    <v-list-item v-bind="props">
                                        <v-icon :icon="menu.icono"></v-icon>
                                        {{ menu.nombre }}
                                    </v-list-item>
                                </template>

                                <template v-for="(submenu, subindex) in filteredSubmenus(menu.id)" :key="subindex">
                                    <v-list-item :to="submenu.enlace" :value="submenu.nombre" rounded="xl">
                                        <v-icon :icon="submenu.icono"></v-icon>
                                        {{ submenu.nombre }}
                                    </v-list-item>
                                </template>
                            </v-list-group>
                        </template>
                    </v-list-group>

                </v-list>
                <v-list-item @click="dialog = true" prepend-icon="mdi mdi-logout" title="Salir del sistema"
                    value="login"></v-list-item>
            </v-navigation-drawer>
            <v-main style="min-height: 100vh" class="mt-5">
                <slot>
                </slot>
            </v-main>
        </v-layout>
    </v-card>



    <v-dialog v-model="dialog" persistent width="auto" transition="dialog-bottom-transition">

        <v-card class="px-5 py-5">
            <v-card-text class="text-center">
                <v-icon class="as-rotate" icon="mdi mdi-lock" size="100" color="red"></v-icon>
            </v-card-text>
            <p class="text-h4 text-center">¿Esta seguro de salir del sistema?</p>

            <div class="as-bt-actions-logout">
                <v-btn color="orange" variant="outlined" @click="dialog = false">
                    Cancelar
                </v-btn>
                <v-btn color="green-darken-1" variant="outlined" @click="cerrarSesion()">
                    Aceptar
                </v-btn>

            </div>


        </v-card>
    </v-dialog>
</template>

<script>
import Login from '@/services/Login';
import Menus from "@/services/Menus";
import { useRouter } from 'vue-router';
import { defineComponent, ref } from 'vue';

export default defineComponent({
    data() {

        const menus_obj = new Menus();
        const submenus_obj = new Menus();

        const userlogeado = new Login();
        const userrolelogeado = new Login();


        const user = [];
        /* const user = {
            nombres:"",
        }; */
        const login = new Login();
        const dialog = false;
        const router = useRouter();
        const menuItems = ref([
            {
                title: "Registros",
                active: false,
                subMenuItems: ["Pistolas", "Cuchillos", "Sables"]
            },
        ]);
        const adminMenuItems = ref([
            {
                title: "Administración",
                active: false,
                subMenuItems: ["Usuarios", "Admin", "ejemploas"]
            },
        ]);
        const certMenuItems = ref([
            {
                title: "Certificaciones",
                active: false,
                subMenuItems: ["Reposisciones", "Resarcimientos", "Certificados Gral", "Pistolas", "Bayonetas"]
            },
        ]);
        const repoMenuItems = ref([
            {
                title: "Reportes",
                active: false,
                subMenuItems: ["Reportes Dotacion Ejercito"]
            },
        ]);
        const reposicionesMenu = ref([
            {
                title: "Reposiciones",
                active: false,
                subMenuItems: ["Reposiciones por Fuerza"]
            },
        ]);

        return {
            drawer: true,
            items: [],
            rail: false,
            user,
            login,
            dialog,

            datos: [],
            datosub: [],
            menus_obj,
            submenus_obj,

            userlogeado,
            userrolelogeado,
            userData: null,
            roluserData: null,

            router,
            menuItems,
            repoMenuItems,
            certMenuItems,
            adminMenuItems,
            reposicionesMenu
        }
    },
    mounted() {
        this.registros();
        this.getUserData();
        this.getUserRolData();
    },
    computed: {
        filteredSubmenus() {
            return (menuId) => {
                return this.datosub.filter(submenu => submenu.submenu === menuId);
            };
        }
    },
    methods: {

        async getUserData() {
            try {
                const user = await this.userlogeado.userme();
                this.userData = user;
                console.log("Este es el usuario", this.userData);
            } catch (error) {
                console.error("Error al obtener los datos del usuario:", error);
            }
        },
        async getUserRolData() {
            try {
                const user = await this.userrolelogeado.userroleauth();
                this.roluserData = user;
                console.log("Este es el usuario con su rol", this.roluserData);
            } catch (error) {
                console.error("Error al obtener los datos del usuario:", error);
            }
        },
        shouldShowMenu(menu) {
            return menu.enlace === '/' && this.filteredSubmenus(menu.id).length > 0;
        },
        async registros() {
            this.change_table = "cyan";
            try {
                /* const response = await this.menus_obj.menuget();
                        console.log("Quiero ver la respuesta", response); */
                const response = await this.menus_obj.rolusermenuget();
                console.log("Quiero ver la respuesta de response menu general", response);

                /* const responsesub = await this.submenus_obj.submenuget();
                console.log("Esta es la respuesta", responsesub); */
                const responsesub = await this.submenus_obj.rolusersubmenuget();
                console.log("Esta es la respuesta", responsesub);

                if (response.status) {
                    this.datos = response.records;
                    console.log("Esta es la respuesta de personas status", this.datos);
                } else {
                    console.error("Respuesta inválida o sin registros.");
                }

                if (responsesub.status) {
                    this.datosub = responsesub.records;
                    console.log("Esta es la respuesta de personas status", this.datosub);
                } else {
                    console.error("Respuesta inválida o sin registros.");
                }

                // Mostrar el id de cada menú
                const idsMenus = this.datos.map((menu) => menu.id);
                console.log(`ID del menú general: `, idsMenus);

                this.datos.forEach((menu) => {
                    console.log(`ID del menú: ${menu.id}`);
                });

                // Mostrar el id de cada submenú
                this.datosub.forEach((submenu) => {
                    console.log(`ID del submenú: ${submenu.id}`);
                    console.log(`ID del menú asociado al submenú: ${submenu.submenu}`);
                });

                this.change_table = null;
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        },
        async cerrarSesion() {
            const estado = await this.login.logoutUser();
            if (estado.status) {
                this.router.push("/");
            }
        }
    },
    async mountedauth() {
        const usuario = await this.login.auth();
        console.log("Respuesta de auth:", usuario);

        if (usuario && usuario.user) {
            this.user = usuario.user;
            console.log("Este es el usuario", this.user);
        } else {
            console.error("La respuesta de auth no contiene la propiedad 'user'.", usuario);
        }
    }

});

</script>